module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "otherbooks",
    attrs: {
      "id": "adc"
    }
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("Also by Joy Bauer")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 90/10 Weight-Loss Plan")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Complete Idiot’s Guide to Total Nutrition")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("Also by Rosemary Black")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Kids’ Holiday Baking Book")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f678db28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781429983969_epub_adc_r1.vue
// module id = 60
// module chunks = 0